<template>
  <main>
    <v-container class="booking-table">
      <v-toolbar flat class="main-header mb-6">
        <v-toolbar-title class="main-header__title">
          <h1>Sponsors</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="my-auto mx-1 radius-12"
            color="success"
            to="/content/sponsors/create"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />
      <v-data-table
        :headers="sponsorsTableHeaders"
        :loading="loadingDataTable"
        :items="sponsors"
        :mobile-breakpoint="zero"
        :items-per-page="200"
        hide-default-footer
        class="table"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell name text-center">
              {{ item.order || "---" }}
            </td>
            <td class="table__cell text-center">
              {{ item.name || "---" }}
            </td>
            <td class="table__cell text-center">
              <v-img
                height="50px"
                width="70px"
                class="radius-12 mx-auto"
                v-if="item.photo != null"
                :src="item.photo ? item.photo.path : '--'"
              ></v-img>
              <span v-else>No Pic</span>
            </td>
            <td class="table__cell name text-center">
              <a :href="item.video ? item.video.path : '--'" target="_black"
                >Link</a
              >
            </td>
            <td class="table__cell text-center">
              <router-link
                :to="{ name: 'editSponsors', params: { id: item.id } }"
                class="hovering mr-1 edit"
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span @click="handleDelete(item, index)" class="hovering delete">
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      sponsors: [],
      sponsorsTableHeaders: [],
      pagination: {},
      queries: {},
      loadingDataTable: false,
      zero: 0
    };
  },
  created() {
    this.busStopHeaders();
  },
  methods: {
    indexSponsors(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: "content/sponsors", query })
        .then(res => {
          const { data, meta } = res.data;
          this.sponsors = data;
          this.pagination = meta;
          this.loadingDataTable = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    busStopHeaders() {
      const headersList = ["Order", "Name", "Photo", "Video", "Actions"];
      this.sponsorsTableHeaders = TableHeaders(headersList);
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/content/sponsors`,
            id: id
          })
            .then(() => {
              this.sponsors.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.indexSponsors(query);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
